import Dialog, { IDialogProps } from '@/ui/dialog';
import { Button } from '@/ui/buttons';
import { CloseX } from '@/ui/svg';
// import { useTranslation } from '@/i18n';
import CopyText from '../common/Copy';
import {
  useEditWallet,
  useGlobalValueStore,
  useWallets,
} from '@bitbot/model';
import clsx from 'clsx';
import { Notify } from '@bitbot/ui-design';
import InputWalletName from './input-wallet-name';
import { useEffect } from 'react';

interface IEditWalletProps extends IDialogProps {
  currentWallet: { name: string; address: string } | undefined;
}

export default function EditWalletDialog({
  currentWallet,
  ...props
}: IEditWalletProps) {
  // const { t } = useTranslation();
  const { editWallet, name, setName } = useEditWallet(
    currentWallet?.name ?? '',
  );
  useEffect(() => {
    if (props.open) {
      setName(currentWallet?.name ?? '');
    }
  }, [props.open]);
  const { getWallets } = useWallets();
  const { showInputWalletName, setShowInputWalletName } =
    useGlobalValueStore();
  return (
    <Dialog {...props}>
      <div className="px-2">
        {showInputWalletName && (
          <InputWalletName name={name} setName={setName} />
        )}
        <div className="flex flex-col flex-grow font-nunito_sans gap-6 px-4">
          <div className="flex flex-col gap-2">
            <div className="text-tertiary">Name</div>
            <div className="relative flex">
              <div
                onClick={() => {
                  setShowInputWalletName(true);
                }}
                className={clsx(
                  'bg-transparent outline-none border-primary border-[1px] rounded-2xl w-0 flex-grow py-3 pl-4 pr-8 ',
                  name === '' ? 'text-quaternary' : '',
                )}
              >
                {name === '' ? 'Wallet name' : name}
              </div>
              {name !== '' && (
                <div
                  onClick={() => {
                    setShowInputWalletName(true);
                  }}
                  className="absolute w-8 top-0 bottom-0 right-0 flex items-center cursor-pointer"
                >
                  <CloseX className="w-5 h-5 text-tertiary" />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-tertiary">Address</div>
            <div className="relative flex justify-between items-center">
              <div className="text-xs break-all">
                {currentWallet?.address}
              </div>
              <div className="h-6 w-6 flex items-center text-tertiary">
                <CopyText content={currentWallet?.address} />
              </div>
            </div>
            <hr className="border-primary mb-2 mt-3" />
          </div>
          {/* <div className="flex flex-col gap-2">
            <div>Master Wallet (EOA)</div>
            <Button onClick={() => {}} type="primary" size="sm">
              Setup
            </Button>
            <div className="rounded-xl bg-tertiary py-2 px-[0.625rem] text-secondary flex justify-between gap-2">
              <Info className="w-5 h-5 flex-shrink-0" />
              <div className="text-sm tracking-thin flex-grow">
                You will be redirected to the Bitbot website, where you can
                link your EOA wallet to setup.
              </div>
            </div>
            <div className="relative flex justify-between items-center">
              <div className="text-xs">
                0x7D1b52aCd37Cae171803163076dfA5DC3754eF77
              </div>
              <div className="h-6 flex items-center">
                <Link />
              </div>
            </div>
            <div className="rounded-xl bg-orange-accent/15 py-2 px-[0.625rem] text-orange-accent flex justify-between gap-2">
              <Info className="w-5 h-5 flex-shrink-0" />
              <div className="text-sm tracking-thin flex-grow">
                Please keep your Master wallet secure. The Master wallet
                can modify this wallet’s permissions and access all its
                funds.
              </div>
            </div>
            <hr className="border-primary" />
          </div> */}
          <div className="flex gap-[0.625rem] mb-2 font-bold text-xl">
            <Button
              type="disabled"
              onClick={() => {
                props.toggle(false);
              }}
              size="xs"
              className="bg-tertiary rounded-2xl w-1/2 py-[0.875rem] cursor-pointer text-center !text-white"
            >
              Cancel
            </Button>
            <Button
              size="xs"
              onClick={() => {
                if (name.trim() === '') return;
                editWallet(name, currentWallet?.address!)
                  .then(() => {
                    props.toggle(false);
                    Notify.success('Change wallet name successful');
                    getWallets(false);
                  })
                  .catch(() => {
                    Notify.success(
                      'Change wallet name failed, please try it again',
                    );
                  });
              }}
              type="normal"
              className={clsx(
                'rounded-2xl w-1/2 py-[0.875rem] cursor-pointer text-center',
                name.trim() === '' && 'opacity-80',
              )}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
